import * as request from '../../request'
import * as serializers from './serializers'

export const getWallets = async (options) => {
  try {
    const res = await request.get('v1/wallets', options)

    return serializers.getWallets(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getPriorityMatrixResource = async (options) => {
  try {
    const res = await request.get(
      'v1/filters/store-priority-matrices?is_simple_list=true',
      options
    )

    return serializers.filtersSerialize(res.data)
  } catch (err) {
    return Promise.reject(err)
  }
}
